import { getYoutubeVideoCover } from "@/utils/youtube";
import BlogContent from "../BlogContent";
import { BLOG_TAGS } from "../BlogTags";

const PODCAST_2: BlogContent = {
    id: 14,
    label: "Gyvenimo būdo poveikis biologiniam laikrodžiui",
    description: "Sužinokite, kas yra epigenetika ir biologinis laikrodis, kaip gyvensenos įpročiais galima koreguoti šiuos rodiklius ir kuris įprotis gali turėti daugiausiai įtakos.",
    descriptionInner: "Sužinokite, kas yra epigenetika ir biologinis laikrodis, kaip gyvensenos įpročiais galima koreguoti šiuos rodiklius ir kuris įprotis gali turėti daugiausiai įtakos",
    img_src: getYoutubeVideoCover("kCTO1IDAgPI"),
    alt: "Podcastas nr.2",
    tags: [BLOG_TAGS.PODCASTS.label, BLOG_TAGS.LIFESTYLE.label],
    // more_blogs_ids: [1, 2, 3],
    author: "Laidos vedėjas: Farmacininkas - Jokūbas Malikėnas.",
    innerData: [
    {
        id: 1,
        description: [
            "Šiame epizode aptariama, kas yra epigenetika ir biologinis laikrodis, kaip gyvensenos įpročiais galima koreguoti šiuos rodiklius ir kuris įprotis gali turėti daugiausiai įtakos.",
            "Specialistai dalinasi praktiniais pavyzdžiais, kokius biologinius žymenis galima išsitirti, kaip reaguoti sužinojus rezultatus bei kokius žingsnius žengti siekiant prevenciškai pasirūpinti savo sveikata.",
            "Laidos svečiai: Genetikas ir ilgaamžiškumo pradininkas bei gyvensenos medicinos praktikė - dr. Vaidas Dirsė ir Vaiva Zinkevičiūtė-Balsė.",
            "Laidos vedėjas: Farmacininkas - Jokūbas Malikėnas."
        ]
    }],
    podcasts: {
        youtube: "kCTO1IDAgPI",
        spotify: "6xgBuWaXT2dbVEBUK05Qlx?si=090675b1fd784cda",
        apple: "1000729478393"
    }
}

export default PODCAST_2;